import { AuthChangePerspectiveAction } from "../actions/AuthChangePerspective";
import { AuthState } from "../state";

export function authChangePerspective(state: AuthState, action: AuthChangePerspectiveAction) {
    return { ...state, asUser: action.payload.asUser };
}